import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaPlusCircle, FaClipboardList, FaCheckSquare, FaFileUpload } from "react-icons/fa";
import styles from "../SampleControl.module.css";
import NewOrderModal from "../../components/ui/NewOrderModal";
import CocUploadModal from "../../components/ui/CocUploadModal";

const SampleControlDashboard = () => {
    const navigate = useNavigate();
    const [statistics, setStatistics] = useState({
        pendingOrders: 0,
        pastDue: 0,
        inProgress: 0
    });
    const [loading, setLoading] = useState(false);
    const [showNewOrderModal, setShowNewOrderModal] = useState(false);
    const [showCocUploadModal, setShowCocUploadModal] = useState(false);

    useEffect(() => {
        loadStatistics();
    }, []);

    const loadStatistics = async () => {
        try {
            setLoading(true);
            // TODO: Replace with actual API calls
            // const accessToken = await getBackendAccessToken();
            // const data = await sampleControlService.getStatistics(accessToken);
            
            // Placeholder data
            setStatistics({
                pendingOrders: 15,
                pastDue: 3,
                inProgress: 8
            });
        } catch (error) {
            console.error('Failed to load sample control statistics:', error);
        } finally {
            setLoading(false);
        }
    };

    /**
     * Handle new order created
     * @param {Object} order - Newly created order
     */
    const handleOrderCreated = (order) => {
        console.log('New order created:', order);
        // TODO: Navigate to order details page or refresh statistics
        // For now, just refresh statistics
        loadStatistics();
        
        // Optionally navigate to the order details or samples page
        // navigate(`/samples/order/${order.orderId}`);
    };

    return (
        <div className={styles.dashboard}>
            {/* Statistics Section */}
            <div className={styles.statsGrid}>
                <div className={styles.statCard}>
                    <h3>Pending Orders</h3>
                    <div className={styles.statNumber}>{statistics.pendingOrders}</div>
                    <div className={styles.statLabel}>Awaiting Processing</div>
                </div>
                <div className={styles.statCard}>
                    <h3>Past Due</h3>
                    <div className={`${styles.statNumber} ${statistics.pastDue > 0 ? styles.danger : ''}`}>
                        {statistics.pastDue}
                    </div>
                    <div className={styles.statLabel}>Requires Attention</div>
                </div>
                <div className={styles.statCard}>
                    <h3>In Progress</h3>
                    <div className={`${styles.statNumber} ${styles.warning}`}>{statistics.inProgress}</div>
                    <div className={styles.statLabel}>Currently Active</div>
                </div>
            </div>

            {/* Sample Control Actions */}
            <div className={styles.quickActions}>
                <h3>Sample Control Actions</h3>
                <div className={styles.actionGrid}>
                    <button 
                        className={styles.actionButton}
                        onClick={() => setShowNewOrderModal(true)}
                    >
                        <span className={`${styles.actionIcon} ${styles.createOrder}`}><FaPlusCircle /></span>
                        <span>Create New Order</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/samples/view-orders')}
                    >
                        <span className={`${styles.actionIcon} ${styles.viewOrders}`}><FaClipboardList /></span>
                        <span>View Orders</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => setShowCocUploadModal(true)}
                    >
                        <span className={`${styles.actionIcon} ${styles.cocUpload}`}><FaFileUpload /></span>
                        <span>Create Order from COC</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/samples/verify-cocs')}
                    >
                        <span className={`${styles.actionIcon} ${styles.verifyCocs}`}><FaCheckSquare /></span>
                        <span>Verify COCs</span>
                    </button>
                </div>
            </div>

            {/* New Order Modal */}
            <NewOrderModal
                isOpen={showNewOrderModal}
                onClose={() => setShowNewOrderModal(false)}
                onOrderCreated={handleOrderCreated}
            />

            {/* COC Upload Modal */}
            <CocUploadModal
                isOpen={showCocUploadModal}
                onClose={() => setShowCocUploadModal(false)}
            />
        </div>
    );
};

export default SampleControlDashboard;
